import homePageImage from '../images/IMG_7374.jpeg';
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css'

// var ReactGridLayout = require("react-grid-layout");

/*
 * TODO:
 *    Add background colors
 *    Update color scheme with Heta's input
 *    Fix the text fonts 
 *    
 * 
 */

export function Home() {
    const regularInfo = [
        <b>જય શ્રી સ્વામિનારાયણ 🙏🏽</b>,
        <Table></Table>,
        "Satsang Sabha every Saturday from 5:00PM to 7:30PM.",
        "Maha-Prasad will be served after Thal, Aarti.",
        <Table></Table>,
        <b>Arti Times:</b>,
        "Monday to Friday: 7:00AM and 7:30PM",
        "Weekends and Holidays: 8:00AM and 7:30PM",
        <Table></Table>,
        "For more information about Shree Swaminarayan Sampraday, Please Visit",
        <a href='http://www.swaminarayan.nu' target='blank'>www.swaminarayan.nu</a>,
      ];

    return (
        <div className ="home-container">
            <div className="side">
                <img src={homePageImage} alt="Jay Shree Swaminarayan" className='home-img' />
            </div>
            <div className="side side-content-center">
                <Table className='info-table'>
                  {regularInfo.map((item,index) => (
                  <tr key={index} className={`tr-${index}`}>
                      {/*<td width={"2%"}></td>*/}
                      {item}
                  </tr>
                  ))}
              </Table>
            </div>
        </div>
    );
}